export default __webpack_public_path__ + "static/media/Admitidos_Economia2023_24.0f49b9a5.pdf";